import { render, staticRenderFns } from "./ManageClients.vue?vue&type=template&id=0809f6a8&scoped=true&"
import script from "./ManageClients.vue?vue&type=script&lang=js&"
export * from "./ManageClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0809f6a8",
  null
  
)

export default component.exports